<details class="tw-pt-10 tw-w-full tw-px-4" [open]="true">
  <summary
    class="active:tw-outline-none dark:tw-text-gray-300 focus:tw-outline-none tw-font-bold tw-mb-2 tw-text-[18px] tw-text-primary-700 tw-text-right"
  >
    {{ "common.appearanceSettings" | translate }}
  </summary>

  <div class="tw-flex-center tw-max-w-full tw-px-4">
    <div
      class="2xl:tw-w-4/5 xl:tw-w-[85%] lg:tw-w-full tw-flex md:tw-flex-row tw-flex-col tw-items-center"
    >
      <!-- theme -->
      <div class="tw-w-full md:tw-w-1/2 tw-flex-center tw-flex-col">
        <!-- label -->
        <span
          class="tw-font-semibold tw-mb-2 tw-text-[18px] tw-text-gray-500 dark:tw-text-gray-200"
        >
          {{ "common.chooseTheme" | translate }}
        </span>

        <!-- theme list -->
        <div class="tw-flex tw-flex-wrap tw-justify-center">
          @for ( theme of formBuilderThemesEnumValues; track $index ) {
          <div
            (click)="onSelectedTheme(theme.key)"
            [ngClass]="
              selectedTheme == theme.key
                ? 'tw-bg-primary-50 dark:tw-bg-primary-900/40 tw-border-primary-200 dark:tw-border-primary-400 tw-text-primary-400'
                : 'tw-bg-gray-100 hover:tw-bg-gray-200  tw-border-gray-100 hover:tw-border-gray-200 dark:tw-bg-dark-100 dark:tw-border-dark-100 tw-text-gray-600 dark:tw-text-gray-300 '
            "
            class="tw-w-36 tw-cursor-pointer tw-p-3 tw-my-2 tw-rounded-md tw-mx-2 tw-flex tw-justify-between tw-items-center tw-border"
          >
            <span class="tw-text-base tw-font-semibold">
              {{ theme.value }}
            </span>
            <span [formBuilderThemeColor]="theme.key"></span>
          </div>
          }
        </div>
      </div>

      <!--backgroundImagePath-->
      <div class="md:tw-w-1/2 tw-w-full md:tw-mt-0 tw-mt-4">
        <image-uploader
          (imgSrc)="emitFile($event)"
          [returnFile]="true"
          [imageSrc]="imageUrl"
          [imageLoading]="imageLoading"
          imageUploaderTitle="common.logoUpload"
          imageUploaderSize="xl:tw-h-64 lg:tw-h-56 tw-h-48 tw-w-full"
        ></image-uploader>
      </div>
    </div>
  </div>
</details>
